var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33144 0.765747H5.65397C2.63529 0.765747 0.737549 2.90616 0.737549 5.93021V14.0992C0.737549 17.1232 2.62545 19.2538 5.65397 19.2538H14.3265C17.3649 19.2538 19.243 17.1232 19.243 14.0992V10.1718",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71607 8.7481L14.0612 1.41382C14.2786 1.19621 14.5368 1.02355 14.8211 0.905758C15.1054 0.787962 15.4102 0.727417 15.718 0.727417C16.0258 0.727417 16.3307 0.787962 16.615 0.905758C16.8993 1.02355 17.1575 1.19621 17.3749 1.41382L18.5745 2.61163C18.7924 2.82869 18.9653 3.08665 19.0833 3.37054C19.2012 3.65442 19.262 3.95872 19.262 4.26608C19.262 4.57343 19.2012 4.87773 19.0833 5.16162C18.9653 5.44551 18.7924 5.70334 18.5745 5.92041L11.19 13.294C10.9923 13.4908 10.7576 13.6468 10.4995 13.7529C10.2413 13.8591 9.96478 13.9133 9.68561 13.9126H5.99829L6.08678 10.2013C6.10482 9.65488 6.32969 9.13549 6.71607 8.7481V8.7481Z",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9402 2.5528L17.4338 7.02991",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostEdit);
export default __webpack_public_path__ + "static/media/post_edit.6874ea074979715f09197f713e3152cf.svg";
export { ForwardRef as ReactComponent };